import React, { Component } from 'react';
import { Vector } from 'prelude-ts';

import Subgoal from './Subgoal';

import Statement from '../Statement';

import styles from '../styles/PlayArea.module.css';
import { Rule } from '../Rule';

interface Props {
  subgoals: Vector<Statement>;
  executor: (statement: Statement['id'], rule: Rule) => void;
  draggingEnabled: boolean;
  tooltip: boolean;
}

class PlayArea extends Component<Props> {
  render() {
    return (
      <div className={styles.playArea}>
        {this.props.subgoals.map(statement => (
          <Subgoal
            key={statement.id}
            statement={statement}
            executor={this.props.executor}
            draggingEnabled={this.props.draggingEnabled}
            tooltip={this.props.tooltip}
          />
        ))}
      </div>
    );
  }
}

export default PlayArea;
